import React, { Component } from "react";
import { isEmail } from "../../../../_utils";
import { Link } from "react-router-dom";
export default class ForgotPassword extends Component {
  state = { email: "", showText: false };
  _handleSubmit = event => {
    event.preventDefault();
    const { onForgotPassword } = this.props;
    const { email, password } = this.state;
    const onSuccess = () => {
      this.setState({ showText: true });
    };
    const onError = () => {
      this.setState({ showText: true });
    };
    onForgotPassword({ email, onSuccess, onError });
  };
  getDisableState = () => {
    const { email } = this.state;
    if (!isEmail(email)) {
      return true;
    }

    return false;
  };
  render() {
    const { onForgotPassword } = this.props;
    const { email, showText } = this.state;
    return (
      <div class="dev-page-login-block__form">
        <form onSubmit={this._handleSubmit}>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group margin-top-30">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={event => {
                    this.setState({ email: event.target.value });
                  }}
                />
              </div>
            </div>
          </div>

          <div class="form-group no-border">
            <button
              class="btn btn-danger btn-block"
              disabled={this.getDisableState()}
              type="submit"
            >
              Forgot Password
            </button>
          </div>
          {showText ? (
            <p>We've sent an email message on how to reset your password.</p>
          ) : null}
          <p class="text-center">OR</p>
          <div class="form-group no-border">
            <Link
              to={`/login`}
              className="btn btn-success btn-block"
              type="button"
            >
              Login
            </Link>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Login/ForgotPassword/index.js